













































































































import { Component, Vue } from "vue-property-decorator";
import { bus } from "@/main.ts";
import { Getter } from "vuex-class";
import { Contract } from "@/services/contracts/types";
import { Instance, Device } from "@/services/instances/types";
import { getInstances, getOneTimeToken } from "@/services/instances/instanceService";
import { instancesFields } from "@/components/instances/fields/instancesFields";
import { RoleEnum } from "@/store/authentication/types";
import vSelect from "vue-select";
const namespace: string = "authentication";

@Component({
    components: {
        vSelect
    }
})
export default class Instances extends Vue {
    @Getter("reload") reload: any;
    @Getter("authorize", { namespace }) authorize: any;
    roles = RoleEnum;

    // local state
    instances = [] as Array<Instance>;
    fields = instancesFields;
    isBusy = false;
    sortBy = "name";
    sortDesc = false;

    // filter options
    searchQuery = "";
    selectedVersion = null as any;

    // lifecycle hooks
    public created(): void {
        this.fetchData();

        bus.$on("reload", () => {
            this.fetchData();
        });
    }

    beforeDestroy() {
        bus.$off("reload");
    }

    // computed

    get versionOptions() {
        const uniqueVersions = [...new Set(this.instances.map(instance => instance.versionNumber))];
        return uniqueVersions.map(version => ({ id: version, text: version }));
    }

    get filteredData() {
        return this.instances.map(instance => {
            return {
                ...instance,
                totalLicences: this.getTotalLicences(instance.contracts),
                totalDevices: this.getTotalDevices(instance.devices),
                activeDevices: this.getActiveDevices(instance.devices),
                totalDevicesWithSolution: this.getTotalDevicesWithSolution(instance.devices),
                activeDevicesWithSolution: this.getActiveDevicesWithSolution(instance.devices)
            };
        }).filter(instance => {
            const matchesSearch = this.searchQuery.length === 0 ||
                instance.name.toLowerCase().includes(this.searchQuery.toLowerCase());

            const matchesVersion = !this.selectedVersion || instance.versionNumber === this.selectedVersion.id;

            return matchesSearch && matchesVersion;
        });
    }

    getTotalLicences(contracts: Contract[]): number {
        if (!contracts || contracts.length === 0) return 0;

        return contracts.reduce((total, contract) => {
            if (contract.licences) {
                // Sum all numeric values in the licences object
                total += Object.values(contract.licences)
                    .map(val => Number(val) || 0)
                    .reduce((sum, n) => sum + n, 0);
            }
            return total;
        }, 0);
    }

    getActiveDevicesWithSolution(devices: Device[]): number {
        if (!devices || devices.length === 0) return 0;
        const now = new Date();
        const toleranceMinutes = 70; // 1 hour + 10 minutes
        const thresholdTime = new Date(now.getTime() - toleranceMinutes * 60000); // Convert minutes to milliseconds
        return devices.filter(device =>
            !device.isOutOfSync &&
            device.lastActiveDate &&
            new Date(device.lastActiveDate + "Z") >= thresholdTime &&
            device.solutionId // Ensure a solution is assigned
        ).length;
    }

    getActiveDevices(devices: Device[]): number {
        if (!devices || devices.length === 0) return 0;

        const now = new Date();
        const toleranceMinutes = 70; // 1 hour + 10 minutes
        const thresholdTime = new Date(now.getTime() - toleranceMinutes * 60000); // Convert minutes to milliseconds
        return devices.filter(device =>
            !device.isOutOfSync &&
            device.lastActiveDate &&
            new Date(device.lastActiveDate + "Z") >= thresholdTime
        ).length;
    }

    getTotalDevices(devices: Device[]): number {
        if (!devices || devices.length === 0) return 0;

        return devices.filter(device => !device.isOutOfSync).length;
    }

    getTotalDevicesWithSolution(devices: Device[]): number {
        if (!devices || devices.length === 0) return 0;

        return devices.filter(device => !!device.solutionId && !device.isOutOfSync).length;
    }

    // methods
    navigateToInstance(id: string, baseUrl: string) {
        getOneTimeToken(id).then(response => {
            window.open(
                `${baseUrl}/oneTimeLogin?t=${response}`,
                "_blank"
            );
        });
    }

    fetchData() {
        this.isBusy = true;
        getInstances().then(response => {
            this.instances = response;
            this.isBusy = false;
        });
    }

    clearFilter() {
        this.searchQuery = "";
        this.selectedVersion = null;
    }
}
